import GetAllFaqsUseCase from './use-cases/GetAllFAQ';
import { IGetAllFaqsUseCase } from './interfaces/faqs';
import AbstractModuleFactory from '@core/shared/module-factory';

export class FAQModuleFactory extends AbstractModuleFactory {
  /**
   * Use case that handle the FAQ query
   */
  createGetAllFaqsUseCase(): IGetAllFaqsUseCase {
    return this.ensureInstance('GetAllFaqsUseCase', () => new GetAllFaqsUseCase());
  }

  static new(): FAQModuleFactory {
    return new FAQModuleFactory();
  }
}

export default FAQModuleFactory.new();
